<template>
  <div :class="['addressList', isSelection ? 'selectionAddressList' : '']">
    <ul class="list">
      <li
        class="item"
        v-for="item in addressList"
        :key="item.CRId"
        @click="getEditAddress(item)"
      >
        <img
          class="default"
          v-if="item.IsDefult == 1"
          src="~assets/img/myCustomer/icon_label@2x.png"
        />
        <div class="itemLeft">
          <section class="userBox">
            <p class="userName">{{ item.ReceivingName }}</p>
            <p class="userPhone">{{ item.PhoneNumber }}</p>
          </section>
          <!-- 邮编 -->
          <p class="postcode">{{ $t.address.postcode }}: {{ item.PostalCode }}</p>
          <p class="address">{{ item.ReceivingAddress }}</p>
        </div>
        <figure class="itemRight">
          <div class="actionBox" v-if="!isSelection">
            <van-icon size="20" name="arrow" />
          </div>
          <div class="actionBox" v-if="isSelection" @click.stop="editAddress(item)">
            <van-icon size="20" name="edit" />
          </div>
        </figure>
      </li>
    </ul>
  </div>
</template>
<script>
import Vue from "vue";
import { Icon } from "vant";

Vue.use(Icon);
export default {
  name: "AddressList",
  props: ["addressList", "isSelection"],
  data() {
    return {};
  },
  methods: {
    getEditAddress(item) {
      this.$emit("addressDidTap", item);
    },
    editAddress(item) {
      this.$emit("editAddress", item);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
@mixin publicP {
  font-size: 13px;
  color: #333333;
  margin-top: 12px;
}
.selectionAddressList {
  margin-bottom: 25vh !important;
}
.addressList {
  margin-bottom: 15vh;
  * {
    margin: 0;
    padding: 0;
  }
  .list {
    width: 100%;
    margin-top: 10px;
    .item:first-child {
      border-top: 1px solid #ebedf0;
    }
    .item {
      overflow: hidden;
      position: relative;
      width: 100%;
      box-sizing: border-box;
      padding: 0 0 0 25px;
      border-bottom: 1px solid #ebedf0;
      @include publicFlex;
      .default {
        position: absolute;
        left: 0px;
        top: 0px;
        width: 50px;
      }
      .itemLeft {
        min-width: 85%;
        max-width: 85%;
        .userBox {
          padding-top: 20px;
          @include publicFlex;
          .userName {
            font-size: 15px;
            color: #000000;
            font-weight: bold;
          }
          .userPhone {
            font-size: 13px;
            color: #a7a7a7;
            margin-left: 22px;
            flex: 1;
            -wbkit-flex: 1;
          }
        }
        .postcode {
          @include publicP;
        }
        .address {
          @include publicP;
          padding-bottom: 20px;
        }
      }
      .itemRight {
        min-width: 15%;
        text-align: right;
        .actionBox {
          margin: 1rem 0;
          color: #999;
          text-align: center;
        }
      }
    }
  }
}
</style>
